import React from 'react';
import Icon from '../../../AppIcon';

const WelcomeHeader = ({ user, currentRole, stats }) => {
  const getCurrentTime = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-gradient-to-r from-primary to-accent rounded-lg p-6 text-white mb-6">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h1 className="text-2xl font-bold mb-2">
            {getCurrentTime()}, {user?.name}!
          </h1>
          <p className="text-white/90 mb-4">
            Welcome to your {currentRole?.name} dashboard. Here's what's happening today.
          </p>
          
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Icon name="Calendar" size={16} className="text-white/80" />
              <span className="text-sm text-white/90">
                {new Date()?.toLocaleDateString('en-US', { 
                  weekday: 'long', 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} className="text-white/80" />
              <span className="text-sm text-white/90">
                {new Date()?.toLocaleTimeString('en-US', { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </span>
            </div>
          </div>
        </div>
        
        <div className="hidden lg:flex items-center space-x-4">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl font-bold text-white">{stat?.value}</div>
              <div className="text-xs text-white/80">{stat?.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;